import { ICommercetoolsCart } from "../models/icommercetools-cart";

//Order type for tracking (ECOM-3769). The three values are prescribed by the customer and go into
//the datalayer.push (customerType) and the Econda event (orderType) unchanged.
export const OrderCustomerType = {
	Guest: "Gastbestellung",
	Existing: "Bestandskunde",
	New: "Neuregistrierung"
};

const CheckoutRegistrationKey = "checkoutRegistration";

/**
 * Remembers that the customer entered the checkout through the new registration. From the redirect to
 * /checkout-adressen onwards they are just another customer on the server - the distinction from an
 * existing customer only exists here. sessionStorage, so the mark dies with the tab.
 */
export const MarkCheckoutRegistration = (): void => {
	try {
		sessionStorage.setItem(CheckoutRegistrationKey, "true");
	} catch (err) {
		//Without sessionStorage the order counts as an existing customer. That costs tracking accuracy
		//and must not make the registration itself fail.
	}
};

const TakeCheckoutRegistration = (): boolean => {
	try {
		const isMarked = sessionStorage.getItem(CheckoutRegistrationKey) === "true";
		sessionStorage.removeItem(CheckoutRegistrationKey);
		return isMarked;
	} catch (err) {
		return false;
	}
};

/**
 * Determines the type of the order that was just submitted. Called exactly once on submit and consumes
 * the registration mark in doing so, so that it can no longer colour a follow-up order. Guest detection
 * as in assets/react/register-guest/index.tsx: no customer account, but a guest email address.
 */
export const GetOrderCustomerType = (cart: ICommercetoolsCart): string => {
	const billingAddress = cart?.Order?.BillingAddress ?? cart?.CurrentAddresses?.BillingAddress;
	const isRegistration = TakeCheckoutRegistration();

	if (!cart?.CustomerId && billingAddress?.GuestEmailAddress) {
		return OrderCustomerType.Guest;
	}

	return isRegistration ? OrderCustomerType.New : OrderCustomerType.Existing;
};
